// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__162Zw","inner":"Footer_inner__2rywA"};